/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Sort_Pcreleasedate2Inputs */

const id_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tanggal Rilis PC`)
};

const ms_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarikh Keluaran PC`)
};

const da_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Udgivelsesdato`)
};

const de_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-Veröffentlichungsdatum`)
};

const en_us2_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Release Date`)
};

const es_es2_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento en PC`)
};

const es_mx2_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fecha de lanzamiento en PC`)
};

const fil_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Petsa ng PC Release`)
};

const fr_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de sortie PC`)
};

const it_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data uscita PC`)
};

const hu_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC megjelenés dátuma`)
};

const nl_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pc-releasedatum`)
};

const no_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-utgivelsesdato`)
};

const pl_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data premiery na PC`)
};

const pt_br2_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento para PC`)
};

const pt_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data de lançamento no PC`)
};

const ro_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data lansării pe PC`)
};

const fi_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-julkaisupäivä`)
};

const sv_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC-releasedatum`)
};

const vi_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày phát hành PC`)
};

const tr_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC Çıkış Tarihi`)
};

const cs_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum vydání na PC`)
};

const bg_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата на издаване за PC`)
};

const ru_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата выхода на ПК`)
};

const uk_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дата виходу на ПК`)
};

const ar_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تاريخ إصدار PC`)
};

const hi_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC रिलीज़ तारीख़`)
};

const th_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วันที่วางจำหน่าย PC`)
};

const ja_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC リリース日`)
};

const zh_cn2_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC发布日期`)
};

const zh_hant1_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC發布日期`)
};

const ko_search_sort_pcreleasedate2 = /** @type {(inputs: Search_Sort_Pcreleasedate2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PC 출시일`)
};

/**
* | output |
* | --- |
* | "PC Release Date" |
*
* @param {Search_Sort_Pcreleasedate2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_sort_pcreleasedate2 = /** @type {((inputs?: Search_Sort_Pcreleasedate2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Sort_Pcreleasedate2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_sort_pcreleasedate2(inputs)
	if (locale === "ms") return ms_search_sort_pcreleasedate2(inputs)
	if (locale === "da") return da_search_sort_pcreleasedate2(inputs)
	if (locale === "de") return de_search_sort_pcreleasedate2(inputs)
	if (locale === "en-US") return en_us2_search_sort_pcreleasedate2(inputs)
	if (locale === "es-ES") return es_es2_search_sort_pcreleasedate2(inputs)
	if (locale === "es-MX") return es_mx2_search_sort_pcreleasedate2(inputs)
	if (locale === "fil") return fil_search_sort_pcreleasedate2(inputs)
	if (locale === "fr") return fr_search_sort_pcreleasedate2(inputs)
	if (locale === "it") return it_search_sort_pcreleasedate2(inputs)
	if (locale === "hu") return hu_search_sort_pcreleasedate2(inputs)
	if (locale === "nl") return nl_search_sort_pcreleasedate2(inputs)
	if (locale === "no") return no_search_sort_pcreleasedate2(inputs)
	if (locale === "pl") return pl_search_sort_pcreleasedate2(inputs)
	if (locale === "pt-BR") return pt_br2_search_sort_pcreleasedate2(inputs)
	if (locale === "pt") return pt_search_sort_pcreleasedate2(inputs)
	if (locale === "ro") return ro_search_sort_pcreleasedate2(inputs)
	if (locale === "fi") return fi_search_sort_pcreleasedate2(inputs)
	if (locale === "sv") return sv_search_sort_pcreleasedate2(inputs)
	if (locale === "vi") return vi_search_sort_pcreleasedate2(inputs)
	if (locale === "tr") return tr_search_sort_pcreleasedate2(inputs)
	if (locale === "cs") return cs_search_sort_pcreleasedate2(inputs)
	if (locale === "bg") return bg_search_sort_pcreleasedate2(inputs)
	if (locale === "ru") return ru_search_sort_pcreleasedate2(inputs)
	if (locale === "uk") return uk_search_sort_pcreleasedate2(inputs)
	if (locale === "ar") return ar_search_sort_pcreleasedate2(inputs)
	if (locale === "hi") return hi_search_sort_pcreleasedate2(inputs)
	if (locale === "th") return th_search_sort_pcreleasedate2(inputs)
	if (locale === "ja") return ja_search_sort_pcreleasedate2(inputs)
	if (locale === "zh-CN") return zh_cn2_search_sort_pcreleasedate2(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_sort_pcreleasedate2(inputs)
	return ko_search_sort_pcreleasedate2(inputs)
});
export { search_sort_pcreleasedate2 as "search.sort.pcReleaseDate" }